import React from 'react';

export const NotFound = ({ ...props }) => {
  return (
    <article className="search-input-dropdown-not-found" {...props}>
      <span className="search-input-dropdown-not-found-title">Não encontramos nenhum resultado.</span>
      <span className="search-input-dropdown-not-found-description">Faça uma nova busca.</span>
    </article>
  );
};
